/* eslint-disable spire/export-styles */

import React, { FC } from "react";
import { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { connect } from "react-redux";

export interface EmptyCartContainerStyles {
    container?: InjectableCss;
}

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles: EmptyCartContainerStyles = {
    container: {
        css: css`
            & div[data-test-selector^="productCarousel_crossSells"] {
                margin-bottom: 40px;
                div[class^="GridItemStyle"] {
                    margin-bottom: 0;
                }
                button[data-test-selector^="prevBtn"] {
                    left: -15px;
                }
                button[data-test-selector^="nextBtn"] {
                    right: -15px;
                }
            }
            & .categoryTitle {
                display: none;
            }
        `,
    },
};

export const emptyCartContainerStyles = styles;

const EmptyCartContainer: FC<Props> = ({ id, cart }) => {
    return (
        <>
            {cart?.cartLines?.length === 0 && (
                <StyledWrapper {...styles.container}>
                    <Zone contentId={id} zoneName="emptyCartContent" />
                </StyledWrapper>
            )}
        </>
    );
};

const emptyCartContainer: WidgetModule = {
    component: connect(mapStateToProps, null)(EmptyCartContainer),
    definition: {
        group: "Common",
    },
};

export default emptyCartContainer;
